import { useEffect, useCallback } from 'react';
import {
    usePaymentErrorPopup,
    hidePaymentErrorPopup,
} from '../stores/paymentErrorPopupStore';

const PaymentErrorPopup = () => {
    const { isOpen, message, buttons } = usePaymentErrorPopup();

    useEffect(() => {
        if (!isOpen) return undefined;

        const onKey = (e) => {
            if (e.key === 'Escape') hidePaymentErrorPopup();
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);

        return () => {
            document.body.style.overflow = prevOverflow;
            document.removeEventListener('keydown', onKey);
        };
    }, [isOpen]);

    const handleButtonClick = useCallback((button) => {
        try {
            if (typeof button?.onClick === 'function') {
                button.onClick();
            }
        } catch (err) {
            console.error('[PaymentErrorPopup] button onClick threw:', err);
        } finally {
            hidePaymentErrorPopup();
        }
    }, []);

    if (!isOpen) return null;

    return (
        <div
            className="payment-error-popup-overlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="payment-error-popup-title"
        >
            <div className="payment-error-popup">
                <h2 id="payment-error-popup-title" className="payment-error-popup-title">
                    Payment failed
                </h2>
                {message && (
                    <p className="payment-error-popup-message">{message}</p>
                )}
                <div className="payment-error-popup-buttons">
                    {buttons.map((button, index) => {
                        const variant = button.variant
                            || (index === 0 ? 'primary' : 'secondary');
                        return (
                            <button
                                key={index}
                                type="button"
                                className={`payment-error-popup-button ${variant}`}
                                onClick={() => handleButtonClick(button)}
                            >
                                {button.text}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PaymentErrorPopup;
